import { Alert, Button, Group, Stack, Text } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import { useTheme } from '@contexts/ThemeContext';
import { JarvisPrimaryButton } from '@components/jarvis-ui';

export interface ColleagueFilledPanelProps {
  title: string;
  /** Label/value rows, e.g. the colleague's tempat, nama, jabatan. */
  details?: Array<{ label: string; value: string }>;
  continueLabel: string;
  keepLabel: string;
  onContinue: () => void;
  onKeep: () => void;
  busy?: boolean;
}

/**
 * Top-of-step notice that a colleague filled this step's data while the user
 * was in the wizard. "Lanjut" skips the step as done, the other action keeps
 * the step open.
 */
export default function ColleagueFilledPanel({
  title,
  details,
  continueLabel,
  keepLabel,
  onContinue,
  onKeep,
  busy = false,
}: ColleagueFilledPanelProps) {
  const { colors: themeColors } = useTheme();
  return (
    <Alert
      variant="light"
      color="blue"
      icon={<IconUsers size={18} />}
      title={title}
      mb="md"
      data-colleague-panel
      styles={{ title: { color: themeColors.text }, message: { color: themeColors.text } }}
    >
      <Stack gap="sm">
        {details && details.length > 0 && (
          <Stack gap={2}>
            {details.map((row) => (
              <Group key={row.label} gap="xs" wrap="nowrap" align="baseline">
                <Text size="sm" style={{ color: themeColors.textSecondary, minWidth: 150 }}>
                  {row.label}
                </Text>
                <Text size="sm" fw={600} style={{ color: themeColors.text }}>
                  {row.value || '-'}
                </Text>
              </Group>
            ))}
          </Stack>
        )}
        <Group gap="sm">
          <JarvisPrimaryButton size="sm" onClick={onContinue} loading={busy}>
            {continueLabel}
          </JarvisPrimaryButton>
          <Button
            size="sm"
            variant="outline"
            onClick={onKeep}
            disabled={busy}
            styles={{ root: { borderColor: themeColors.border, color: themeColors.text } }}
          >
            {keepLabel}
          </Button>
        </Group>
      </Stack>
    </Alert>
  );
}
